/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';

import { datadogRum, Site } from '@datadog/browser-rum';

import { AppConstants } from './app/app.constants';

import { appConfig } from './app/app.config';

import { IAppSettings } from './app/models/app-settings.model';

import { AppUtilityService } from './app/services/app-utility.service';

import { AppComponent } from './app/app.component';

import { versionInfoDTO } from './app/models/versionInfoDTO.model';
window
  .fetch('./config.json?v=[version]')
  .then((res) => res.json())
  .then(
    async (settings: IAppSettings) => {
    console.log('setting', settings);
    (<any>window)[AppConstants.AppSettings] = settings;
    const versionResponse = await fetch(`${settings.coreApiPath}${AppConstants.UsersServiceEndPoint}${AppConstants.GetVersionInfo}`);
    const versionData: versionInfoDTO = await versionResponse.json();
    (<any>window)[AppConstants.AppVersion] = versionData.version;
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json"},
    };

    fetch(settings.dataDogHKRUMUrl, requestOptions)
      .then((response) => {
          console.log("Response:", response)
          if (response.status === 202) {
              console.log('DD_HK_Service online.')
              loadDataDogSite(true, settings.dataDogHKSite);
          } else {
              console.log('DD_HK_Service offline. Redirecting to backup URL.')
              loadDataDogSite(false, settings.dataDogSZSite);
          }
      })
      .catch((error) => {
          console.log('DD_HK_Service offline on error. Redirecting to backup URL.', error)
          loadDataDogSite(false, settings.dataDogSZSite);
      });  

    /********************************************
    // Custom Properties for Datadog  - start
    *********************************************/
    function loadDataDogSite(isDataDogUrlAccessible: boolean, ddSite: Site | undefined) {
      datadogRum.init({
        applicationId: settings.dataDogApplicationId,
        clientToken: settings.dataDogClientToken,
        site: ddSite,        
        ...(!isDataDogUrlAccessible && {
            proxy: (options) => `https://${settings.dataDogSZSite}${options.path}?${options.parameters}`
        }),
        service: settings.dataDogService,
        env: settings.dataDogEnvironmentName,
        version: versionData.version,
        allowedTracingUrls: [
          settings.secondaryApiPath,
          settings.fileManagerApiPath,
          settings.coreApiPath,
          settings.reportApiPath,
        ],
        sessionSampleRate: +settings.dataDogSessionSampleRate,
        sessionReplaySampleRate: +settings.dataDogSessionReplaySampleRate,
        trackUserInteractions: AppUtilityService.toBoolean(settings.dataDogTrackUserInteractions),
        trackResources: AppUtilityService.toBoolean(settings.dataDogTrackResources),
        trackLongTasks: AppUtilityService.toBoolean(settings.dataDogTrackLongTasks),
        defaultPrivacyLevel: settings.dataDogDefaultPrivacyLevel,
      });
    }
    /********************************************
     // Custom Properties for Datadog  - end
     *********************************************/
    bootstrapApplication(AppComponent, appConfig).catch((err) =>
      console.error(err)
    );
  });
